import { ProcurementStatusEnum } from "@/main/services/enum/StatusProcurement";

interface ICanCorrectCartPriceParams {
	idProcurementStatus: number;
	isUserSupplier: boolean;
	showPrices: boolean;
	hasCorrectPriceControl: boolean;
}

export function canCorrectCartPrice({
	idProcurementStatus,
	isUserSupplier,
	showPrices,
	hasCorrectPriceControl,
}: ICanCorrectCartPriceParams): boolean {
	return (
		idProcurementStatus === ProcurementStatusEnum.WaitingRelease &&
		!isUserSupplier &&
		showPrices &&
		hasCorrectPriceControl
	);
}
